export class Sound {
	constructor(game) {
		this.game = game;
		this.soundOff = false;
		this.backgroundSound = new Audio('./sound/background-sound.mp3');
		this.jump = new Audio('./sound/jump.mp3');
		this.coin = new Audio('./sound/coin.mp3');
		this.allSounds = [
			this.backgroundSound,
		];
	}

	playBackgroundSound() {
		if (!this.soundOff) {
			this.backgroundSound.play();
		}
	}

	playJump() {
		if (!this.soundOff) {
			this.jump.currentTime = 0;
			this.jump.play();
		}
	}

	playCoin() {
		if (!this.soundOff) {
			this.jump.currentTime = 0;
			this.coin.play();
		}
	}

	off() {
		this.soundOff = true;
		this.backgroundSound.pause();
	}

	on() {
		this.soundOff = false;
		this.backgroundSound.play();
	}
}
